export const ADD_NETWORK_SUCCESS_MESSAGE =
    "Network has been added successfully.";

export const ADD_NETWORK_FAIL_MESSAGE = "Adding a new network has failed.";

export const ADD_NETWORK_FAIL_RETRY_MESSAGE =
    "Adding a new network has failed. Please try again.";

export const NETWORK_ID_VALIDATION_MESSAGE =
    "Network ID must be 24 characters long. It must not contain leading or trailing spaces.";

export const NETWORK_NAME_VALIDATION_MESSAGE =
    "Please enter a valid name for network (min 1 char and max 32 chars, do not include special characters)"

    export const NETWORK_ID_HELPER_TEXT = () => (
    <>
        You can find your Network ID in the PSL Mobile App under <em>PanL Network Settings &gt; PanL Network Information</em> or in the PSL Web Management Console (WMC) under <em>Network Details</em>.
    </>
);

export const NETWORK_NAME_HELPER_TEXT = () => (
    <>
        You can find your Network Name in the PSL Mobile App under <em>PanL Network Settings &gt; PanL Network Information</em> or in the PSL Web Management Console (WMC) under <em>Network Details</em>.
    </>
);